import {
  getTeamApplicationOverview,
  getTeamEndpointOverview,
  getServiceInstancesOverview,
  getTeamAlarm,
  getAppsByCap,
  getUsersImpacted,
  topAlertsByCap,
  topAppsByAlert,
  apdexScores,
  topAppsByRespTime,
  notificationStatus,
  getSummaryMetric,
  metricRate,
  getApdexAppList,
} from '../fragments/home';

export const queryGetTeamApplication = `query getTeamApplicationOverview(${getTeamApplicationOverview.variable}) {${getTeamApplicationOverview.query}}`;

export const queryGetTeamEndpoint = `query getTeamApplicationOverview(${getTeamEndpointOverview.variable}) {${getTeamEndpointOverview.query}}`;

export const queryGetTeamAlarm = `query getTeamAlarm(${getTeamAlarm.variable}) {${getTeamAlarm.query}}`;

export const queryGetServiceInstancesOverview = `query getServiceInstancesOverview(${getServiceInstancesOverview.variable}) {${getServiceInstancesOverview.query}}`

/**
 * 
 * Revampled Query
 */

export const queryGetApplicationByCap = `${getAppsByCap.query}`;
export const queryGetUsersImpacted = `${getUsersImpacted.query}`;
export const queryTopAlertsByCap = `${topAlertsByCap.query}`;
export const queryTopAppsByAlert = `${topAppsByAlert.query}`;
export const queryApdexScores =`${apdexScores.query}`;
export const queryTopAppByRespTime = `${topAppsByRespTime.query}`;
export const querynotificationtime = `${notificationStatus.query}`;
export const queryApdexAppList = `query getApdexAppList(${getApdexAppList.variable}) {${getApdexAppList.query}}`;

/**
 * Custom dashboard query
 */

export const queryDashboardSummary = `query dashboardSummary(${getSummaryMetric.variable}) {${getSummaryMetric.query}}`;
export const queryMetricRate = `query queryData(${metricRate.variable}) {${metricRate.query}}`;